export default __webpack_public_path__ + "static/media/testtubes.90951749.jpg";